import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetBO } from '../../pages.modal';
import { ManageService } from '../manage-service.service';
import { ServiceActivityDataservice } from './service-activitydateservice';
import { functionpermission, ManageServiceBO, saveMasterServiceActivityBO, serviceactivityBO } from '../manage-service.modal';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-service-activity',
  templateUrl: './service-activity.component.html',
  styleUrls: ['./service-activity.component.scss']
})
export class ServiceActivityComponent implements OnInit {
  groupId:any;
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridServiceActivityGroup') public gridServiceActivityGroup: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  saveserviceactivitymap:saveMasterServiceActivityBO = new saveMasterServiceActivityBO();
  ServiceGroupList: any = [];
  ServiceCodeList: any = [];
  isSaveorUpdateBoolean:boolean=false;
  MSFilterBo: serviceactivityBO = new serviceactivityBO();
  ModalType: string="new";
  ServiceActivityArray: any = [];
  constructor(public DateService: ServiceActivityDataservice,
    public Msservice: ManageService,
    public global: GlobalComponent, public toasterservice: ToastrService) {
    
    this.GridList=DateService;
  }
fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    // this.MSFilterBo.field="serviceGroupName";
    // this.MSFilterBo.orderColumn="serviceGroupName";
    this.getServiceActivityFilter();
    this.GetServiceGroupDropdown();
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Manage Services");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.Msservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  // ................................................dataChangeServiceActivity..............................................
  public dataChangeServiceActivity(SG): void {
    let val = (SG.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((SG.sorted || []).length) {
        this.MSFilterBo.orderColumn = SG.sorted[0].name;
        this.MSFilterBo.orderType = SG.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && SG.action.action != "clearFilter") {
      this.MSFilterBo.value = SG.action.currentFilterObject.value;
      this.MSFilterBo.field = SG.action.currentFilterObject.field;
      this.MSFilterBo.matchCase = SG.action.currentFilterObject.matchCase;
      this.MSFilterBo.operator = SG.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && SG.action.action == "clearFilter") {
        this.MSFilterBo.field = "serviceGroupName";
        this.MSFilterBo.matchCase = false;
        this.MSFilterBo.operator = "contains";
        this.MSFilterBo.value = "";
        this.MSFilterBo.type = "string";
      }
    }
    this.getServiceActivityFilter();
    if (val == "paging" && SG.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }
    //.........................................onActionServiceActivity.....................................................
    public onActionServiceActivity(SG) {
      this.MSFilterBo.currentpageno = this.gridServiceActivityGroup.pageSettings.currentPage;
      this.MSFilterBo.pageitem = this.gridServiceActivityGroup.pageSettings.pageSize;
      if (SG.name == "actionBegin" && SG.requestType == "filterbeforeopen") {
        this.MSFilterBo.type = SG.columnType
      }
    }
    // ............................................................................................................................//


    CreateupdateServiceActivity(type: string) {
      if (type == 'new') {
        this.ModalType = 'new';
        this.ServiceActivityArray1 = [];
        this.selectedActivities = [];
        this.availableActivities = [];
        this.groupId='';
        this.valuchangesServiceActivity();
      } else {
        this.valuchangesServiceActivity();
        this.ModalType = 'edit';
      }
    }



  //...........................................getDetails..........................................//
  ServiceActivityArray1: any = [];
  getDetails(data ) {
    this.groupId = data.serviceGroupId
    this.GetServiceCodeDropdown(this.groupId);
   this.ServiceActivityArray1.serviceId = data.serviceId;
   setTimeout(() => {
    this.getActivityTypeSatus(this.ServiceActivityArray1.serviceId);

  }, 1000);
  
  }
  //............................................Refresh...................................................
  Refresh() {
     this.saveserviceactivitymap = new saveMasterServiceActivityBO();
    this.getServiceActivityFilter();

  }

  //.........................................getServiceActivityFilter.............................................
  getServiceActivityFilter() {
    this.DateService.execute(this.MSFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridServiceActivityGroup.height = '500';
      }
      else {
        this.gridServiceActivityGroup.height = 'auto';
      }
    })
  }
// ..............................................................................................................................//
 SaveOrUpdateServiceActivity (ServiceActivityArray1) {  
  this.isSaveorUpdateBoolean=true;
  ServiceActivityArray1.serviceId = ServiceActivityArray1.serviceId;
  if (this.selectedActivities.length != 0) {
    this.selectedActivities.forEach(element => {
      // element.serviceId = ServiceActivityArray1.serviceId,
        element.id = "00000000-0000-0000-0000-000000000000"
        element.serviceId = ServiceActivityArray1.serviceId,
        element.ActivityId = element.Key
        
    })
  }
  else {
    this.selectedActivities.push({
      serviceId: ServiceActivityArray1.serviceId
    })
  }


     this.Msservice.saveServicesActivity(this.selectedActivities).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        this.valuchangesServiceActivity();
       
        if (this.ModalType == 'new') {
          this.toasterservice.success('ServiceActivity saved successfully', 'ServiceActivity Saved');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
          document.getElementById('openServiceActivityModal').click();
        }
         else {
          this.toasterservice.success('ServiceActivity updated successfully', 'ServiceActivity Updated');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
          document.getElementById('openServiceActivityModal').click();
        }
        this.getServiceActivityFilter();
      } 



    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }






 



  
  //.........................................SaveOrUpdateServiceActivity .............................................
  // SaveOrUpdateServiceActivity (serviceId) {
  //    let savepayload: saveMasterServiceActivityBO = JSON.parse(JSON.stringify(this.saveserviceactivitymap));
  //    savepayload.id = this.saveserviceactivitymap.id;
   
   
   
  //    this.Msservice.saveServicesActivity(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //        if (this.saveserviceactivitymap.id == '00000000-0000-0000-0000-000000000000') {
  //          this.toasterservice.success('Service Group saved successfully!');
  //         setTimeout(() => {
  //           this.toasterservice.clear();
  //         }, 8000);

  //        }
  //        else if (this.saveserviceactivitymap.id != '00000000-0000-0000-0000-000000000000') {
  //         this.toasterservice.success('Service Group updated successfully!');
  //          setTimeout(() => {
  //           this.toasterservice.clear();
  //         }, 8000);
  //       }
  //       document.getElementById('openServiceActivityModal').click();
  //        this.saveserviceactivitymap = new saveMasterServiceActivityBO();
  //       this.getServiceActivityFilter();
  //   }, (err: any) => {
  //     if (err) {
  //       this.toasterservice.error(err, 'Error'), 8000;
  //     }
  //   })
  // }

  showServiceActivityColumns() {
    this.gridServiceActivityGroup.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................DeleteServiceActivity ...........................................................
  DeleteServiceActivity () {
    let params = new URLSearchParams();
     params.append("Id", this.saveserviceactivitymap.id);
    this.Msservice.DeleteServiceActivity(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('Service Activitymapping deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('closeSAModal').click();
      this.getServiceActivityFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  clearServiceActivity() {
    this.saveserviceactivitymap = new saveMasterServiceActivityBO();
    this.ServiceActivityArray1.serviceId=null
    this.groupId=null
    this.availableActivities=[]
    this.selectedActivities=[]
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  //..........................................GetServiceGroupDropdown...........................................................
  //  GetServiceGroupDropdown() {
  //   this.Msservice.GetServiceGroupDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.ServiceGroupList = data; 
  //     console.log(this.ServiceGroupList)
  //   }, (err: any) => {
  //     if (err) {
  //       this.toasterservice.error(err, 'Error'), 8000;
  //     }
  //   });
  // }
// .....................................................................................................................//

GetServiceGroupDropdown() {
  this.Msservice.GetServiceGroupDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    this.ServiceGroupList = data; 
    this.ServiceGroupList.forEach(element => {
      element.label = element.name;
      element.value = element.id;
    })
  });
}




////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
 
  selectedServiceID: string;
  availableActivities: any = [];
  selectedActivities: any = [];
  
 
  
  getActivityTypeSatus(serviceGroupId) {
   
    
    let params = new URLSearchParams();
    params.append("serviceId", serviceGroupId);
    this.Msservice.getActivityStatusList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
 
      this.availableActivities = data.availableActivityList;
      
      this.selectedActivities = data.selectedAcitivityList;
    });
  }

 //..........................................GetServiceCodeDropdown...........................................................
  Service:any=[]
 GetServiceCodeDropdown(serviceGroupId) {
  let params = new URLSearchParams();
  params.append("serviceGroupId", serviceGroupId);
  this.Msservice.GetServiceCodeDropdown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    this.Service = data;
  }, (err: any) => {
    if (err) {
      this.toasterservice.error(err, 'Error'), 8000;
    }
  });
}

  // ..................................................................Drag and Drop..................................
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }
isViewServiceActivityMapping= false;
checkpopServiceActivity() {
  this.isViewServiceActivityMapping = true;
}


valuchangesServiceActivity() {
  this.isViewServiceActivityMapping = false;
}



}


